import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuthState } from 'src/contexts/authContext'
import Carousel from 'src/components/Carousel'

const Login = ({ children, leftContent }: { children: React.ReactNode; leftContent?: string }) => {
  const navigate = useNavigate()
  const authState = useAuthState()

  useEffect(() => {
    if (authState.isLoggedIn) {
      navigate('/dashboard')
    }
  }, [])

  return (
    <div className="m-auto grid h-screen max-w-[1366px] grid-flow-col grid-cols-12 content-center">
      <div className="hidden p-8 md:col-span-5 md:block">
        {leftContent ? (
          <div className="flex items-center justify-center">
            <img src={leftContent} alt="Scale" />
          </div>
        ) : (
          <Carousel />
        )}
      </div>

      <div className="col-span-12 w-full p-8 md:col-span-7">
        <div className="h-full md:px-20">{children}</div>
      </div>
    </div>
  )
}

export default Login
